<template lang="pug">
.tabela-nota-fiscal.view-container
    h2(v-if='mostrarTitulo' style='font-weight: bold; padding-bottom: 10px;') Listagem de Nota Fiscal
    el-table(
        :data='dadosTabela',
        stripe,
        style='width: 100%'
    )
        el-table-column(label='Número da nota fiscal', prop='numeroNotaFiscal', min-width='150px', sortable)
            template(slot-scope='scope')
                p {{ scope.row.numeroNotaFiscal }}

        el-table-column(v-if='mostrarCertificada' label='Fazenda Certificada', prop='fazendaCertificada', min-width='150px', sortable)
            template(slot-scope='scope')
                span {{ scope.row.fazendaCertificada || '--' }}

        el-table-column(label='Material', prop='materialDescricao', min-width='150px', sortable)
            template(slot-scope='scope')
                span {{ scope.row.materialDescricao }}

        el-table-column(label='Quantidade', prop='quantidade', min-width='150px', sortable)
            template(slot-scope='scope')
                p {{ scope.row.quantidade }}
        
        el-table-column(label='Data', prop='dataEmissao', min-width='150px', sortable)
            template(slot-scope='scope')
                span {{ scope.row.dataEmissao }}
        
        el-table-column(v-if='mostrarAcoesPadrao' label='Ações', align='left')
            .template.d-flex.justify-content-left(slot-scope='scope')
                el-dropdown.action-button(trigger='click')
                    BaseButton(link)
                        i.el-icon-more
                    el-dropdown-menu(slot='dropdown')
                        el-dropdown-item(
                            icon='el-icon-edit',
                            @click.native='editarNotaFiscal(scope.row)'
                        ) Editar
                        el-dropdown-item(
                            icon='el-icon-delete',
                            @click.native='excluirNotaFiscal(scope.row)'
                        ) Excluir
                        el-dropdown-item(
                            icon='el-icon-view',
                            @click.native='visualizarNota(scope.row.id)'
                        ) Visualizar nota fiscal
                        
        el-table-column(v-if='mostrarAcoesVisaoFazenda' label='Ações', align='left')
            .template.d-flex.justify-content-left(slot-scope='scope')
                el-dropdown.action-button(trigger='click')
                    BaseButton(link)
                        i.el-icon-more
                    el-dropdown-menu(slot='dropdown')
                        el-dropdown-item(
                            icon='el-icon-view',
                            @click.native='visualizarNota(scope.row.id)'
                        ) Visualizar nota fiscal

    .tabela-rodape
        .tabela-rodape--esquerda
            p {{ paginacao.total }} notas fiscais

        .tabela-rodape--pagination
            el-pagination(
                small,
                layout='prev, pager, next',
                :page-size='paginacao.itensPorPagina',
                :current-page.sync='paginacao.pagina',
                :total='paginacao.total',
                @current-change='atualizarPagina(paginacao.pagina - 1)'
            )

    ModalEditarNotaFiscal(
        :mostrar='mostrarModalEditarNotaFiscal',
        :dados='dados',
        @atualizarDados='atualizarDados',
        @fechar='ChangeModalEditar'
    )

    ModalConfirmarExcluir(
        :mostrar='mostrarModalExcluir',
        :dados='dados',
        @atualizarDados='atualizarDados',
        @fechar='ChangeModalExcluir'
    )

</template>

<script>
import formatters from '@/utils/formatters';
import ModalEditarNotaFiscal from '@/components/rastreabilidadeRaizen/notaFiscal/ModalEditarNotaFiscal.vue';
import ModalConfirmarExcluir from '@/components/rastreabilidadeRaizen/notaFiscal/ModalConfirmarExcluir.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'TabelaNotaFiscal',
    emits: ['atualizar-tabela', 'atualizar-pagina'],
    components: {
        ModalEditarNotaFiscal,
        ModalConfirmarExcluir,
        BaseButton
    },
    props: {
        dadosTabela: {
            type: Array,
            default: () => {}
        },
        mostrarTitulo: {
            type: Boolean,
            default: () => true
        },
        mostrarAcoesPadrao: {
            type: Boolean,
            default: () => true
        },
        mostrarAcoesVisaoFazenda: {
            type: Boolean,
            default: () => false
        },
        mostrarCertificada: {
            type: Boolean,
            default: () => true
        },
        paginacao: {
                direcao: null,
                itensPorPagina: 20,
                ordernarPor: null,
                pagina: 0,
                totalPaginas: 0,
                total: 0
        }
    },

    data() {
        return {
            mostrarModalEditarNotaFiscal: false,
            mostrarModalExcluir: false,
            dados: {}
        };
    },

    methods: {
        formatAreaHaTableColumn(row, column, areaHa, index) {
            return formatters.maxFormatNumber(areaHa, 2);
        },

        editarNotaFiscal({
            id,
            numeroNotaFiscal,
            materialDescricao,
            quantidade,
            dataEmissao
        }) {
            this.dados = {
                id,
                numeroNotaFiscal,
                materialDescricao,
                quantidade,
                dataEmissao
            };

            this.mostrarModalEditarNotaFiscal = true;
        },

        excluirNotaFiscal({ id, numeroNotaFiscal}) {
            this.dados = { id, numeroNotaFiscal };
            this.mostrarModalExcluir = true;
        },
        
        ChangeModalEditar() {
            this.mostrarModalEditarNotaFiscal = !this.mostrarModalEditarNotaFiscal;
        },

        ChangeModalExcluir() {
            this.mostrarModalExcluir = !this.mostrarModalExcluir;
        },

        atualizarDados() {
            this.$emit('atualizar-tabela', this.paginacao.pagina - 1);
        },

        atualizarPagina(pagina) {
            this.$emit('atualizar-pagina', pagina);
        },

        visualizarNota(idNotaFiscal) {
            this.$router.push({ name: 'VisualizarNotaFiscal', params: { id: idNotaFiscal }});
        }
    }
};
</script>

<style lang="scss">
.el-table__header-wrapper {
  width: 100%;
  .el-table__header {
    width: 100% !important;
  }
}

// Neede to show the first row in the table
.el-table__body-wrapper {
    width: 100%;
    .el-table__body {
        width: 100% !important;
    }
}

.tabela-selecionar-territorio-monitoramento {
    h3 {
        margin-top: 15px;
        margin-bottom: 15px;
    }
    .el-table {
        box-shadow: 0px 1px 5px 0px var(--block-shadow);
        border-radius: 6px;
    }
    .el-table thead {
        color: var(--primary);
        font-weight: 400;
        font-size: 13px;
    }

    .tabela-btn {
        margin-top: 14px;
        display: flex;
        justify-content: end;
        align-items: center;
    }

    .el-dropdown-link {
        cursor: pointer;
    }
}

.tabela-rodape {
        height: 54px;
        background: var(--white);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 14px 44% 10px 5px;
        margin-top: 8px;
        border-radius: 5px;

        .tabela-rodape--esquerda p {
            margin-bottom: 0;
            color: var(--primary);
            margin-left: 10px;
        }

        .tabela-rodape--pagination {
            .el-pager li.active {
                color: var(--white);
                font-weight: 900;
                background: var(--primary);
            }

            .el-pager li {
                padding: 0 4px;
                background: var(--white);
                vertical-align: top;
                display: inline-block;
                font-size: 13px !important;
                min-width: 28px !important;
                height: 28px !important;
                line-height: 28px !important;
                box-sizing: border-box;
                text-align: center;
                margin: 0;
                border-radius: 2px;
                color: var(--primary);
            }

            .el-pagination button {
                height: 28px;
            }
        }
    }
</style>
